// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"594":"defce9b1","837":"355837cd","852":"56974626"}[chunkId] + ".chunk.css";
};